import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const BoomStateActionTypes = Object.freeze({
  UPDATE_STATE: 'BOOM:UPDATE_STATE',
  CLAIM_REWARD: 'BOOM:CLAIM_REWARD',
  FLUSH_NOTIFICATIONS: 'BOOM:FLUSH_NOTIFICATIONS',
  SKIP_CURRENT_TMP_NOTIFICATION: 'BOOM:SKIP_CURRENT_TMP_NOTIFICATION',
  FILL_TEMPORARY_NOTIFICATIONS: 'BOOM:FILL_TEMPORARY_NOTIFICATIONS',
  REGISTER: 'BOOM:REGISTER',
});

export type BoomStateActionType = ObjectValuesUnionType<typeof BoomStateActionTypes>;
